module.exports = __webpack_public_path__ + "static/img/u3_state0.0627e34f.png";